import React, { useEffect } from 'react';
import EligibilityNav from '../components/eligibility/EligibilityNav';
import EligibilityTop from '../components/eligibility/EligibilityTop';
import EligibilitySupporting from '../components/eligibility/EligibilitySupporting';
import EligibilityFAQ from '../components/eligibility/EligibilityFAQ';
import EligibilityBottomCTA from '../components/eligibility/EligibilityBottomCTA';
import EligibilityFooter from '../components/eligibility/EligibilityFooter';
import { initMotion } from '../utils/motion';

function Eligibility() {
  useEffect(() => {
    window.scrollTo(0, 0);
    const cleanup = initMotion();
    return cleanup;
  }, []);

  return (
    <div className="elig-page">
      <EligibilityNav />
      <EligibilityTop />
      <EligibilitySupporting />
      <EligibilityFAQ />
      <EligibilityBottomCTA />
      <EligibilityFooter />
    </div>
  );
}

export default Eligibility;
